export default __webpack_public_path__ + "static/media/info-circle.0f695a89.svg";